import type { Intervention } from '@seen/core/models/care-plans/intervention'
import { TypographyOverline } from '@seen/ui'
import type { JSX } from 'react'
import { InterventionActivity } from '#src/components/care-plan/interventions/InterventionActivity.tsx'
import { InterventionRoles } from '#src/components/care-plan/interventions/InterventionRoles.tsx'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'
import { FhirReferenceList } from '#src/components/reference/FhirReferenceList.tsx'
import { RichTextEditor } from '#src/components/rich-text-editor/RichTextEditor.tsx'
export function InterventionDisplay({
  intervention,
}: {
  intervention: Intervention
}): JSX.Element {
  return (
    <div className="grid grid-cols-1 gap-4">
      <TypographyOverline>Intervention</TypographyOverline>
      <ResourceFieldForm
        instance={intervention}
        valueFn={(cp) => cp.description}
        patchFn={(cp, description) => {
          cp.description = description
        }}
        debounceTyping
        render={({ field }) => (
          <RichTextEditor
            variant="underline"
            {...field}
            placeholder="Add intervention details..."
          />
        )}
      />
      <div className="grid gap-2">
        <TypographyOverline>Roles</TypographyOverline>
        <InterventionRoles intervention={intervention} />
      </div>
      <div className="grid gap-2">
        {/* Was "All Activity", renamed only because the notes section below is
            now "Activity" and two headings by that name sat next to each other.
            This one is the hand-curated reference list its own control calls
            "Add a reference"; the feed below is the activity. */}
        <TypographyOverline>References</TypographyOverline>
        <ResourceFieldForm
          instance={intervention}
          valueFn={(valueIntervention) => valueIntervention.activityReferences}
          patchFn={(patchIntervention, references) => {
            patchIntervention.activityReferences = references
          }}
          render={({ field }) => (
            <FhirReferenceList
              {...field}
              searchQuery={{
                Appointment: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                CommunicationRequest: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                DeviceRequest: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                MedicationRequest: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                NutritionOrder: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                RequestGroup: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                ServiceRequest: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                Task: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
                VisionPrescription: {
                  patient: intervention.patientSubject,
                  _sort: '-_lastUpdated',
                  _count: '100',
                },
              }}
            />
          )}
        />
      </div>
      <InterventionActivity intervention={intervention} />
    </div>
  )
}
